// extracted by mini-css-extract-plugin
export default {"container":"nav_document_analyzer_link-module__container--4XlpM"};